import { render, staticRenderFns } from "./BookingFlowStepsIcon.vue?vue&type=template&id=08bc1b8c"
import script from "./BookingFlowStepsIcon.vue?vue&type=script&lang=js"
export * from "./BookingFlowStepsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports